/*
  MASHWI — Pixel Meta, événements d'interaction.
  Le code de base, PageView, ViewContent et Search sont posés dans
  snippets/mashwi-meta-pixel.liquid ; ce fichier ajoute ce qui dépend d'un geste
  du visiteur. Tout est enveloppé : une erreur ici ne doit jamais casser le panier.

    AddToCart           — interception des appels /cart/add (formulaire produit,
                          tiroir, ATC collante mobile), plus un repli sur le clic.
    InitiateCheckout    — bouton « Passer au paiement » et boutons de paiement rapide.
    Lead                — infolettre et listes d'attente (ensembles, accessoires).
    CompleteRegistration— création de compte.
    Contact             — formulaire de la page Contact.

  Purchase et AddPaymentInfo ne sont pas ici : le thème n'est pas rendu sur les pages
  de paiement. Voir 04_shopify/CONFIG_ADMIN_MANUEL.md (pixel personnalisé admin).
*/
(function () {
  var P = window.mwPixel;
  if (!P) return;

  var cart = P.cart || { value: 0, numItems: 0, contents: [] };

  function num(v) {
    var n = parseFloat(v);
    return isNaN(n) ? 0 : n;
  }

  /* ---------------------------------------------------------------- AddToCart */

  function trackAdd(items) {
    if (!items || !items.length) return;
    var contents = items.map(function (it) {
      return {
        id: String(it.variant_id || it.id),
        quantity: it.quantity || 1,
        item_price: num((it.final_price != null ? it.final_price : it.price) / 100)
      };
    });
    var value = contents.reduce(function (sum, c) {
      return sum + c.item_price * c.quantity;
    }, 0);

    P.track('AddToCart', {
      content_type: 'product',
      content_ids: contents.map(function (c) { return c.id; }),
      content_name: items[0].product_title || items[0].title || '',
      contents: contents,
      value: Math.round(value * 100) / 100,
      currency: P.currency,
      num_items: contents.reduce(function (s, c) { return s + c.quantity; }, 0)
    });
  }

  function itemsFromAddResponse(data) {
    if (!data || data.status) return null; // { status: 422, description } = erreur panier
    if (Array.isArray(data.items)) return data.items;
    if (data.variant_id || data.id) return [data];
    return null;
  }

  // Rafraîchit l'instantané du panier pour InitiateCheckout.
  function refreshCart() {
    fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart.js' : '/cart.js', {
      headers: { Accept: 'application/json' }
    })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        cart = {
          value: num(c.total_price / 100),
          numItems: c.item_count,
          contents: (c.items || []).map(function (l) {
            return { id: String(l.variant_id), quantity: l.quantity, item_price: num(l.final_price / 100) };
          })
        };
      })
      .catch(function () {});
  }

  var origFetch = window.fetch;
  if (typeof origFetch === 'function') {
    window.fetch = function (input, init) {
      var url = '';
      try {
        url = typeof input === 'string' ? input : (input && input.url) || '';
      } catch (e) {}
      var promise = origFetch.apply(this, arguments);
      if (url && url.indexOf('/cart/add') !== -1) {
        promise
          .then(function (res) {
            try {
              res
                .clone()
                .json()
                .then(function (data) {
                  var items = itemsFromAddResponse(data);
                  if (items) {
                    trackAdd(items);
                    refreshCart();
                  }
                })
                .catch(function () {});
            } catch (e) {}
            return res;
          })
          .catch(function () {});
      }
      return promise;
    };
  }

  // Repli : formulaire d'ajout soumis en POST classique (sans fetch), par exemple si
  // le composant produit de Dawn n'a pas pu s'initialiser.
  //
  // ⚠️ Écouter en phase de BOUILLONNEMENT, pas de capture. Dawn pose son gestionnaire
  // sur le formulaire lui-même et y appelle preventDefault() avant de passer par fetch :
  // à ce stade evt.defaultPrevented vaut true et on sait que l'interception ci-dessus
  // enverra l'événement. En capture, ce test est toujours faux et AddToCart partait
  // EN DOUBLE (constaté en ligne le 2026-07-27).
  //
  // 🐛 CORRIGÉ le 2026-08-11 (15ᵉ passage) — LE PRIX NE VIENT PLUS DE LA PAGE,
  // IL VIENT DU FORMULAIRE. `P.product` n'est posé QUE sur le gabarit produit
  // (snippets/mashwi-meta-pixel.liquid, garde `template.name == 'product'`),
  // et il y est verrouillé sur l'Ensemble de Base. Deux conséquences mesurées
  // le jour où l'accueil s'est mis à vendre :
  //   · accueil → AddToCart à **0 $** (P.product indéfini, le repli valait 0) ;
  //   · fiche, bouton « poêle seul » → AddToCart à **340 $** pour un article
  //     à 299 $, parce que P.product porte l'Ensemble.
  // Une valeur fausse remontée à Meta ne se voit nulle part et pilote pourtant
  // l'optimisation et le ROAS de la campagne. Chaque formulaire d'ajout porte
  // donc `data-mw-prix` en CENTS (prix de la variante réellement vendue) et
  // `data-mw-titre` ; `P.product` ne sert plus que de dernier repli.
  document.addEventListener(
    'submit',
    function (evt) {
      try {
        var form = evt.target;
        if (!form || !form.action || form.action.indexOf('/cart/add') === -1) return;
        if (evt.defaultPrevented) return;
        var vid = form.querySelector('[name="id"]');
        var qty = form.querySelector('[name="quantity"]');
        if (!vid) return;

        var prix = parseInt(form.getAttribute('data-mw-prix'), 10);
        if (!(prix > 0)) prix = P.product ? P.product.value * 100 : 0;
        var titre = form.getAttribute('data-mw-titre') || (P.product ? P.product.content_name : '');

        trackAdd([
          {
            variant_id: vid.value,
            quantity: parseInt(qty && qty.value, 10) || 1,
            price: prix,
            product_title: titre
          }
        ]);
      } catch (e) {}
    },
    false
  );

  /* --------------------------------------------------------- InitiateCheckout */

  var checkoutSent = false;
  function trackCheckout() {
    if (checkoutSent) return;
    checkoutSent = true;
    setTimeout(function () { checkoutSent = false; }, 2000);
    P.track('InitiateCheckout', {
      content_type: 'product',
      content_ids: cart.contents.map(function (c) { return c.id; }),
      contents: cart.contents,
      value: cart.value,
      currency: P.currency,
      num_items: cart.numItems
    });
  }

  document.addEventListener(
    'click',
    function (evt) {
      try {
        var el = evt.target && evt.target.closest
          ? evt.target.closest('[name="checkout"], .shopify-payment-button__button, a[href$="/checkout"]')
          : null;
        if (el) trackCheckout();
      } catch (e) {}
    },
    true
  );

  /* --------------------------------------------------------------------- Lead */

  function trackLead(source) {
    P.track('Lead', {
      content_name: source || 'Infolettre',
      content_category: 'newsletter',
      currency: P.currency,
      value: 0
    });
  }

  document.querySelectorAll('[data-mw-lead-success]').forEach(function (el) {
    trackLead(el.getAttribute('data-mw-lead-success') || 'Infolettre');
  });

  // 🐛 CORRIGÉ le 2026-08-14 — LE BALAYAGE CI-DESSUS NE VOIT PLUS RIEN.
  // Il ne s'exécute qu'une fois, au chargement, et il ne trouvait le marqueur
  // de succès que parce que le formulaire client de Shopify RECHARGEAIT la
  // page. Depuis que les inscriptions partent chez Klaviyo en arrière-plan
  // (assets/mashwi-klaviyo.js), il n'y a plus de rechargement : le marqueur
  // est simplement démasqué, bien après ce balayage, et l'événement Lead
  // n'aurait plus jamais été envoyé — en silence, sans rien casser de visible.
  // Les formulaires annoncent donc leur succès par un événement.
  document.addEventListener('mashwi:lead', function (evt) {
    try {
      trackLead((evt.detail && evt.detail.source) || 'Infolettre');
    } catch (e) {}
  });

  /* ------------------------------------------------------ CompleteRegistration */

  var REG_KEY = 'mwPendingRegistration';

  document.addEventListener(
    'submit',
    function (evt) {
      try {
        var form = evt.target;
        if (!form) return;
        var type = form.querySelector('[name="form_type"]');
        if (type && type.value === 'create_customer') sessionStorage.setItem(REG_KEY, '1');
      } catch (e) {}
    },
    true
  );

  try {
    if (P.loggedIn && sessionStorage.getItem(REG_KEY)) {
      sessionStorage.removeItem(REG_KEY);
      P.track('CompleteRegistration', {
        content_name: 'Compte client',
        status: true,
        currency: P.currency,
        value: 0
      });
    }
  } catch (e) {}

  /* ------------------------------------------------------------------ Contact */

  document.querySelectorAll('[data-mw-contact-success]').forEach(function () {
    P.track('Contact', { content_name: 'Formulaire de contact' });
  });
})();
